import './index.scss';
import { CssBaseline } from '@material-ui/core';
import { Switch, Redirect, Route } from 'react-router-dom';
import PageForgot from './PageForgot';
import PageLogin from './PageLogin';
import PageRecover from './PageRecover';
import PageRegistration from './PageRegistration';
import PageVerify from './PageVerify';
import React from 'react';
import useTheme from '../../../hooks/useTheme';

export function AuthPage () {
    const theme = useTheme();
    return (
        <div className='auth-root'>
            <CssBaseline />
            <header className='auth-root-banner'>
                <img alt="Logo" src={`/${theme.name}/logo-login.png`} />
                <h3 className="font-size-h1 text-white">
                ¡Bienvenido a {theme.label}!
                </h3>
            </header>
            <main className="auth-root-content">
                <Switch>
                    <Route path="/auth/forgot" component={PageForgot} />
                    <Route path="/auth/login" component={PageLogin} />
                    <Route path="/auth/registration" component={PageRegistration} />
                    <Route path="/auth/verify/:token" component={PageVerify} />
                    <Route path="/users/recover" component={PageRecover} />
                    <Redirect from="/auth" exact={true} to="/auth/login" />
                    <Redirect to="/auth/login" />
                </Switch>
            </main>
        </div>
    );
}
